export default __webpack_public_path__ + "static/16_19-988c46a865e6b6cdc1b7b9c50594f586.png";